module.exports = __webpack_public_path__ + "img/space.e2fbaca4.jpg";